import * as React from "react";

interface EstimateErrorPopupProps {
    message: string;
    onClose: () => void;
    heading?: string; // Optional heading prop
}

interface EstimateErrorPopupState {}

class EstimateErrorPopup extends React.Component<EstimateErrorPopupProps, EstimateErrorPopupState> {
    constructor(props: EstimateErrorPopupProps) {
        super(props);
    }

    render() {
        return (
            <div style={styles.overlay}>
                <div style={styles.popup}>
                    <div style={styles.iconContainer}>
                        <svg style={styles.icon} viewBox="0 0 24 24">
                            <path fill="#EF4444" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                    </div>
                    <h3 style={styles.heading}>{this.props.heading || "Something went wrong"}</h3>
                    <p style={styles.message}>{this.props.message}</p>
                    <button style={styles.button} onClick={this.props.onClose}>
                        Dismiss
                    </button>
                </div>
            </div>
        );
    }
}

const styles: { [key: string]: React.CSSProperties } = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(15, 23, 42, 0.88)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
    },
    popup: {
        backgroundColor: "white",
        padding: "32px",
        borderRadius: "16px",
        boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)",
        textAlign: "center",
        maxWidth: "420px",
        width: "90%",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    iconContainer: {
        marginBottom: "16px",
    },
    icon: {
        width: "48px",
        height: "48px",
        color: "#EF4444",
    },
    heading: {
        fontSize: "20px",
        fontWeight: 600,
        color: "#1F2937",
        margin: "0 0 8px 0",
        lineHeight: 1.3,
    },
    message: {
        fontSize: "16px",
        color: "#6B7280",
        lineHeight: 1.5,
        margin: "0 0 24px 0",
    },
    button: {
        backgroundColor: "#3B82F6",
        color: "white",
        border: "none",
        padding: "12px 28px",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.5px",
        transition: "all 0.15s ease",
        boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.2)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },
};

export { EstimateErrorPopup };

// Confirmation popup component for successful actions
interface EstimateConfirmationPopupProps {
    message: string;
    onClose: () => void;
    heading?: string;
}

class EstimateConfirmationPopup extends React.Component<EstimateConfirmationPopupProps, {}> {
    constructor(props: EstimateConfirmationPopupProps) {
        super(props);
    }

    render() {
        return (
            <div style={confirmationStyles.overlay}>
                <div style={confirmationStyles.popup}>
                    <div style={confirmationStyles.iconContainer}>
                        <svg style={confirmationStyles.icon} viewBox="0 0 24 24">
                            <path fill="#10B981" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                        </svg>
                    </div>
                    <h3 style={confirmationStyles.heading}>{this.props.heading || "Success!"}</h3>
                    <p style={confirmationStyles.message}>{this.props.message}</p>
                    <button style={confirmationStyles.button} onClick={this.props.onClose}>
                        Continue
                    </button>
                </div>
            </div>
        );
    }
}

const confirmationStyles: { [key: string]: React.CSSProperties } = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(15, 23, 42, 0.88)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
    },
    popup: {
        backgroundColor: "white",
        padding: "32px",
        borderRadius: "16px",
        boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)",
        textAlign: "center",
        maxWidth: "420px",
        width: "90%",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    iconContainer: {
        marginBottom: "16px",
    },
    icon: {
        width: "48px",
        height: "48px",
        color: "#10B981",
    },
    heading: {
        fontSize: "20px",
        fontWeight: 600,
        color: "#1F2937",
        margin: "0 0 8px 0",
        lineHeight: 1.3,
    },
    message: {
        fontSize: "16px",
        color: "#6B7280",
        lineHeight: 1.5,
        margin: "0 0 24px 0",
    },
    button: {
        backgroundColor: "#10B981",
        color: "white",
        border: "none",
        padding: "12px 28px",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.5px",
        transition: "all 0.15s ease",
        boxShadow: "0 4px 6px -1px rgba(16, 185, 129, 0.2)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },
};

export { EstimateConfirmationPopup };